<template>
  <!-- 答题页 -->
  <div class="ceping82-question">
      <img class="bg" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/TA-bg.png" alt="">
      <img class="blessing-d" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/blessing-d.png" alt="">
      <!-- 答题模块 -->
      <div class="question-main">
          <div @click="checkHandle('时光不老，我们不散，友谊长存~')" :class="['checkbox-row',checkQuestion.includes('时光不老，我们不散，友谊长存~')?'on':'']">
              <img v-if="checkQuestion.includes('时光不老，我们不散，友谊长存~')" class="checkbox-on" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/TA-checkbox.png" alt="">
              <div v-else class="checkbox"></div>
              <div class="text">时光不老，我们不散，友谊长存~</div>
          </div>
          <div @click="checkHandle('感恩老爸老妈一直的照顾，祝身体康泰~')" :class="['checkbox-row',checkQuestion.includes('感恩老爸老妈一直的照顾，祝身体康泰~')?'on':'']">
              <img v-if="checkQuestion.includes('感恩老爸老妈一直的照顾，祝身体康泰~')" class="checkbox-on" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/TA-checkbox.png" alt="">
              <div v-else class="checkbox"></div>
              <div class="text">感恩老爸老妈一直的照顾，祝身体康泰~</div>
          </div>
          <div @click="checkHandle('遇见你是我一生最大的幸运，愿执子之手，与子偕老~')" :class="['checkbox-row',checkQuestion.includes('遇见你是我一生最大的幸运，愿执子之手，与子偕老~')?'on':'']">
              <img v-if="checkQuestion.includes('遇见你是我一生最大的幸运，愿执子之手，与子偕老~')" class="checkbox-on" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/TA-checkbox.png" alt="">
              <div v-else class="checkbox"></div>
              <div class="text">遇见你是我一生最大的幸运，愿执子之手，与子偕老~</div>
          </div>
          <div @click="checkHandle('感谢您对我工作的支持，祝元旦快乐，阖家欢乐~')" :class="['checkbox-row',checkQuestion.includes('感谢您对我工作的支持，祝元旦快乐，阖家欢乐~')?'on':'']">
              <img v-if="checkQuestion.includes('感谢您对我工作的支持，祝元旦快乐，阖家欢乐~')" class="checkbox-on" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/TA-checkbox.png" alt="">
              <div v-else class="checkbox"></div>
              <div class="text">感谢您对我工作的支持，祝元旦快乐，阖家欢乐~</div>
          </div>
          <div @click="checkHandle('我要自己写')" :class="['checkbox-row',optionVal?'on':'']">
              <img v-if="optionVal" class="checkbox-on" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/TA-checkbox.png" alt="">
              <div v-else class="checkbox"></div>
              <div class="text">{{optionVal?optionVal:'我要自己写'}}</div>
          </div>
          <a class="btn" @click="sendLetterHandle()" >装入信封</a>
          <p class="small" @click="resetMail(true)">重写一封</p>
      </div>
      <!-- 自己写祝福语 -->
      <van-popup class="bless-content" v-model="blessShow">
          <div class="child">
              <h4>我要自己写<div class="small">（30个字符以内）</div></h4>
              <van-field class="text" v-model="blessText" rows="1" autosize  type="textarea" placeholder="在这里输入"/>
              <div class="bdr"></div>
              <button @click="saveBlessHandle()" class="btn">生成祝福语</button>
          </div>
      </van-popup>

      <!-- 生成一封信海报 -->
      <van-popup class="book-poster" v-model="posterShow" :close-on-click-overlay="false">
          <div class="child">
              <img v-if="posterLink" :src="posterLink" alt="">
              <p>长按保存，发送给TA</p>
              <button @click="$router.push('/ceping82_bookList');" class="btn">返回书房</button>
          </div>
      </van-popup>
  </div>
</template>

<script>
import { getData,saveData,ceping82_save_data,ceping82_info,ceping82_poster } from '@/api/measurement'
import { deepCopy,getNowFormatDate,isMain } from "@/utils/tools";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            checkQuestion:[],
            blessShow:false,
            blessText:'',
            optionVal:'',
            questionObj:{},
            cid:82,
            info:{},
            // 海报生成
            posterShow:false,
            posterLink:'',
            mailObject:{}
        }
    },
    watch:{
        // 监听输入的祝福语字数长度
        blessText(curVal, oldVal){
			if(curVal.length > 30) {
		      this.blessText = curVal.slice(0, 30);
		      this.$toast('最多只能输入30个字符。/(ㄒoㄒ)/~~');
		    }
        }
    },
    methods:{
        // 重写一封信  bool:为true填写书信，false提交成功清空数据
        resetMail(bool){
            // 提交成功清楚缓存数据
            this.$delete(this.mailObject,'ceping82');
            saveData({
                cid:this.cid,
                data:JSON.stringify(this.mailObject)
            }).then((data)=>{
                if (data.code == "10002") {
                    this.$toast(data.data.msg || data.msg || data.data.detail);
                    return
                }
                if(bool){
                    this.$router.push('/ceping82');
                }
            });
        },
        // 寄信
        sendLetterHandle(){
            if(this.checkQuestion.length==0 && !this.optionVal){
                this.$toast('请先填写祝福语！');
                return
            }
            //调用加载中
            this.$emit('loadingHandle',true,"整理书信中(◍°∇°◍)...");
            let obj = deepCopy(this.questionObj);
            obj['blessing'] = this.checkQuestion.length>0?this.checkQuestion:[this.optionVal];
            obj['from'] = this.info.nickname;
            // 判断数据是否正确
            if(!this.questionObj.name){
                this.$toast('数据不正确！请返回重新填写！');
                return
            }
            ceping82_save_data({
                cid:this.cid,
                data:JSON.stringify(obj)
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if (data.code == "10002") {
                    this.$toast(data.data.msg || data.msg || data.data.detail);
                    return
                }
                //调用加载中
                this.$emit('loadingHandle',true,"海报生成中(◍°∇°◍)...");
                // 生成海报
                ceping82_poster({
                    to:this.questionObj.name,
                    from:this.info.nickname,
                    date:this.questionObj.update_time?this.questionObj.update_time.split(' ')[0]:getNowFormatDate().replace(/-/g, "."),
                    link:`https://open.xjy.cn/${isMain()?'main':'test'}/ceping82_mail?md5=${data.item.md5}&type=poster`,
                    headimgurl:this.info.headimgurl
                }).then((res)=>{
                    //关闭加载中
                    this.$emit('loadingHandle',false);
                    if (res.code == "10002") {
                        this.$toast(res.data.msg || res.msg || res.data.detail);
                        return
                    }
                    this.posterLink = res.poster;
                    this.posterShow = true;
                });
                // 提交成功后，清空缓存数据
                this.resetMail();
                
            });
        },
        // 生成祝福语
        saveBlessHandle(){
            this.optionVal = this.blessText;
            this.blessShow = false;
        },
        // 选择触发
        checkHandle(val){
            if(this.checkQuestion.includes(val)){
                this.$forceUpdate();
                this.checkQuestion.splice(this.checkQuestion.indexOf(val),1);
            }else{
                this.checkQuestion.splice(0,this.checkQuestion.length);
                if(val=='我要自己写'){
                    this.blessShow = true;  
                }else{
                    this.blessText = '';
                    this.optionVal = '';
                    this.checkQuestion.push(val);
                }
            }
        },
        // 获取初始化数据
        pullData(){
            document.title = "写出对TA说的话";
            //调用加载中
            this.$emit('loadingHandle',true,"正在铺纸ヾ(◍°∇°◍)ﾉﾞ...");
            getData({
                cid:this.cid
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if (data.code == "10002") {
                    this.$toast(data.data.msg || data.msg || data.data.detail);
                    return
                }
                if(data.data){
                    this.mailObject = JSON.parse(data.data);
                    // 获取一封信信息
                    this.questionObj =this.mailObject && this.mailObject.ceping82?deepCopy(this.mailObject.ceping82):{};
                    if(this.questionObj.blessing){
                        this.name = this.questionObj.blessing;
                    }
                }
                this.questionObj['update_time'] = data.update_time;
                
            });
            // 第一次进来请求接口，如果已有头像和昵称数据不请求接口
            if(!this.info.nickname || !this.info.headimgurl){
                // 获取用户信息
                ceping82_info().then((data)=>{
                    if (data.code == "10002") {
                        this.$toast(data.data.msg || data.msg || data.data.detail);
                        return
                    }
                    this.info = data;
                });
            }
            shareCon("index", this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background:url('https://themes-cdn.xjy.cn/statics/career/images/ceping82/bg-cover.png') bottom;
    }
    .book-poster{
        background: transparent;
        text-align: center;
        img{
            width: 525px;
            margin-bottom: 30px;
            border-radius: 15px;
        }
        p{
            text-align: center;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 33px;
            margin-bottom: 30px;
        }
        .btn{
            width: 300px;
            line-height: 80px;
            border: none;
            height: 80px;
            background: linear-gradient(180deg, #FF855D 0%, #D13E1D 100%);
            box-shadow: 0px 2px 6px 0px rgba(179, 31, 0, 0.43);
            border-radius: 40px;
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 50px;
            text-shadow: 0px 2px 4px rgba(221, 41, 0, 0.5);
        }
    }
    .bless-content{
        background: transparent;
        .child{
            width: 590px;
            padding: 80px 60px 60px;
            background: #FFFFFF;
            border-radius: 24px;
            display: flex;
            flex-direction: column;
            align-items: center;
            h4{
                font-size: 36px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #875233;
                line-height: 40px;
                margin-bottom: 60px;
                text-align: center;
                display: flex;
                .small{
                    font-size: 24px;
                    color: #A9AFB3;
                }
            }
            .text{
                padding: 0;
                textarea{
                    text-align: center;
                    font-size: 30px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #875233;
                    line-height: 42px;
                    text-align: center;
                    width: 470px;
                }
            }
            .bdr{
                width: 465px;
                height: 2px;
                background: linear-gradient(to right,#F1E2DB,#F1E2DB, #EBBFA4,#F7EBE4,#F7EBE4);
                margin-bottom: 60px;
            }
            .btn{
                width: 300px;
                line-height: 80px;
                border: none;
                height: 80px;
                background: linear-gradient(180deg, #FF855D 0%, #D13E1D 100%);
                box-shadow: 0px 2px 6px 0px rgba(179, 31, 0, 0.43);
                border-radius: 40px;
                font-size: 36px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 50px;
                text-shadow: 0px 2px 4px rgba(221, 41, 0, 0.5);
            }
        }
    }
    .ceping82-question .van-overlay {
        background-color: rgba(0, 0, 0, .7) !important;
    }
</style>
<style lang="scss" scoped>
.ceping82-question{
    position: relative;
    .bg{
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
    }
    .blessing-d{
        margin-top: 212px;
        margin-left: 86px;
        width: 84px;
    }
    .question-main{
        position: relative;
        z-index: 2;
        margin: 200px auto 0;
        .checkbox-row{
            margin: 0 auto 15px;
            width: 560px;
            display: flex;
            align-items: center;
            background: #FFFFFF;
            border-radius: 20px;
            box-sizing: border-box;
            border: 2px solid #FFB8B8;
            padding: 10px 0px 10px 20px;
            min-height: 90px;
            font-size: 28px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #875233;
            &:last-of-type{
                margin-bottom: 50px;
            }
            .checkbox{
                flex-shrink: 0;
                width: 32px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 10px;
                opacity: 0.5;
                border: 2px solid #FFB8B8;
            }
            .checkbox-on{
                flex-shrink: 0;
                width: 32px;
                height: 32px;
            }
            .text{
                line-height: 40px;
                width: 490px;
                margin-left: 10px;
            }
        }
        .checkbox-row.on{
            border: 2px solid #EE5047;
        }
        .btn{
            display: block;
            margin: 0 auto 20px;
            width: 300px;
            line-height: 80px;
            height: 80px;
            background: linear-gradient(180deg, #FF855D 0%, #D13E1D 100%);
            box-shadow: 0px 2px 6px 0px rgba(179, 31, 0, 0.43);
            border-radius: 40px;
            display: block;
            text-align: center;
            text-shadow: 0px 2px 4px rgba(221, 41, 0, 0.5);
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            animation: scaleDraw 2s  infinite;
        }
        .small{
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #875233;
            line-height: 33px;
            text-align: center;
        }
    }
    
}
</style>